import { Flex } from "@chakra-ui/react";
import { SignedIn, SignedOut, SignIn } from "@clerk/clerk-react";
import { Navigate, useLocation } from "react-router-dom";

import { useLinkRouteIntercept } from "../hooks/useLinkRouteIntercept";

import Meta from "~/layout/Meta";

const SignInPage = () => {
  const location = useLocation();
  useLinkRouteIntercept();

  const redirectTo = new URLSearchParams(location.search).get("redirectTo");
  const fullRedirectTo = redirectTo ? `?redirectTo=${redirectTo}` : "";

  return (
    <>
      <Meta title="Sign In" />
      <Flex height={"100dvh"} justify={"center"} align={["top", "center"]}>
        <SignedOut>
          <SignIn routing="hash" signUpUrl={`/signup${fullRedirectTo}`} forceRedirectUrl={redirectTo} />
        </SignedOut>
        <SignedIn>
          <Navigate to={redirectTo || "/"} />
        </SignedIn>
      </Flex>
    </>
  );
};

export default SignInPage;
